export default "__VITE_ASSET__BbGzmahB__"